module.exports = __webpack_public_path__ + "static/media/tor-logo.2f461b12.png";